require('./bootstrap');
require('./fontawesome');
require('./bannerClose');
require('./navbar-burger');
require('./clashCookieConsent');
require('./youtube');
import Vue from 'vue';
// Load all Vue components
let files = require.context('./', true, /\.vue$/i);
// @ts-ignore
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));
if (document.querySelector('#app')) {
    new Vue({
        el: '#app'
    });
}
let video = document.querySelector("#animated_logo");
window.onfocus = () => {
    if (video && video.paused) {
        video.play().then(() => {
        });
    }
};
window.onblur = () => {
    if (video) {
        video.pause();
    }
};
